<form [formGroup]="form" class="form-font-size">
  <textarea
    rows="3"
    pInputTextarea
    ui-inputText
    formControlName="message"
    placeholder="Type a message"
    maxlength="300"
    (keydown.control.enter)="sendMessage()"></textarea>
  <button [disabled]="!form.valid" (click)="sendMessage()" pButton type="button">
    {{ 'send-button-label' | translate }}
  </button>
</form>
